import fullpage from 'fullpage.js';

class Fullpage {

    constructor(id) {

        new fullpage(`#${id}`, {
            scrollBar: true,
            onLeave: () => {
                Misc.hideScrollHint();
            },
            responsiveWidth: 768,
            licenseKey: '6EF54D0B-801E4DD3-B35405CE-A8A48CC4',
        });
    }

    disableScrolling() {
        fullpage_api.setAllowScrolling(false);
    }

    enableScrolling() {
        fullpage_api.setAllowScrolling(true);
    }
}

export default Fullpage;